// extracted by mini-css-extract-plugin
module.exports = {"ArticleInfoPageArticleTextBox":"ArticleDetailsHolder_ArticleInfoPageArticleTextBox__20qhb"};